var map = {
	"./avatar.jpg": 4937,
	"./bitcare.png": 7511,
	"./exact.png": 2659,
	"./freelance.jpg": 1038,
	"./goingwalkabout.png": 9504,
	"./hogeschoolrotterdam.png": 1861,
	"./humanwave.png": 7628,
	"./icon-32.png": 8124,
	"./tno.png": 2260,
	"./yuki-visma.svg": 584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;